class AgarscentsShippingBar extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.message = this.querySelector('.asb-shipping__message');
    this.fill = this.querySelector('.asb-shipping__fill');
    this.render({ total_price: Number(this.dataset.total), item_count: Number(this.dataset.count), currency: this.dataset.currency });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (Number.isFinite(event.cartData?.total_price) && Number.isFinite(event.cartData?.item_count)) this.render(event.cartData);
        else this.refresh();
      });
    }
    this.onPageShow = () => this.refresh();
    this.onVisibility = () => { if (!document.hidden) this.refresh(); };
    window.addEventListener('pageshow', this.onPageShow);
    document.addEventListener('visibilitychange', this.onVisibility);
  }
  disconnectedCallback() {
    this.started = false;
    this.unsubscribe?.();
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }
  async refresh() {
    if (this.pending) return;
    this.pending = true;
    try {
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      this.render(await response.json());
    } catch {
      this.message.textContent = this.dataset.fallback;
      this.fill.style.width = '0%';
    } finally { this.pending = false; }
  }
  render(cart) {
    const currency = cart.currency || this.dataset.currency;
    const shopCurrency = window.Shopify?.currency;
    const rate = currency === 'USD' ? 1 : shopCurrency?.active === currency ? Number(shopCurrency.rate) : NaN;
    const baseGoal = Number(this.dataset.goal);
    if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(baseGoal) || baseGoal <= 0) {
      this.message.textContent = this.dataset.fallback;
      this.fill.style.width = '0%';
      return;
    }
    const goal = Math.ceil(baseGoal * 100 * rate);
    const total = Number(cart.total_price);
    if (!Number.isFinite(total) || total < 0) return;
    const remaining = Math.max(goal - total, 0);
    const formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency });
    const digits = formatter.resolvedOptions().maximumFractionDigits;
    const quantum = 10 ** (2 - digits);
    const displayStep = currency === 'KRW' ? 1000 : 1;
    const amount = cart.item_count
      ? Math.ceil(remaining / quantum) * quantum / 100
      : Math.ceil(goal / 100 / displayStep) * displayStep;
    const displayFormatter = cart.item_count ? formatter : new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency, maximumFractionDigits: 0, minimumFractionDigits: 0 });
    if (cart.item_count && remaining === 0) {
      this.message.textContent = this.dataset.achieved;
    } else {
      const template = cart.item_count ? this.dataset.progress : this.dataset.initial;
      const parts = template.split('__AMOUNT__');
      const money = document.createElement('bdi');
      money.textContent = displayFormatter.format(amount);
      this.message.replaceChildren(document.createTextNode(parts[0]), money, document.createTextNode(parts[1] || ''));
    }
    this.fill.style.width = Math.min(100, total / goal * 100) + '%';
  }
}
if (!customElements.get('agarscents-shipping-bar')) customElements.define('agarscents-shipping-bar', AgarscentsShippingBar);
